import {Controller} from "@hotwired/stimulus"
import input from "daisyui/components/input";

export default class extends Controller {
    connect() {
        function disableElement(element) {
            element.setAttribute('disabled', 'disabled');
        }

        function enableElement(element) {
            element.removeAttribute('disabled');
        }

        function requireElement(element) {
            element.setAttribute('required', 'required');
        }

        function unrequireElement(element) {
            element.removeAttribute('required');
        }

        function hideElement(element) {
            element.setAttribute('hidden', 'hidden');
        }

        function appearElement(element) {
            element.removeAttribute('hidden');
        }

        // English presentation checkbox logic
        const isEnglishCheckbox = document.getElementById('presentation_presentation_attributes_is_english');
        if (isEnglishCheckbox != null) {
            isEnglishCheckbox.addEventListener('click', function () {
                if (this.checked) {
                    disableElement(document.getElementById('presentation_presentation_attributes_title_ja'));
                    unrequireElement(document.getElementById('presentation_presentation_attributes_title_ja'));
                    hideElement(document.getElementById('title-ja'));
                    disableElement(document.getElementById('presentation_presentation_attributes_subtitle_ja'));
                } else {
                    enableElement(document.getElementById('presentation_presentation_attributes_title_ja'));
                    requireElement(document.getElementById('presentation_presentation_attributes_title_ja'));
                    appearElement(document.getElementById('title-ja'));
                    enableElement(document.getElementById('presentation_presentation_attributes_subtitle_ja'));
                }
            });
            if (isEnglishCheckbox.checked) {
                disableElement(document.getElementById('presentation_presentation_attributes_title_ja'));
                unrequireElement(document.getElementById('presentation_presentation_attributes_title_ja'));
                hideElement(document.getElementById('title-ja'));
                disableElement(document.getElementById('presentation_presentation_attributes_subtitle_ja'));
            }
        }

        // Keyword selection logic
        [1, 2, 3, 4, 5].forEach((index) => {
            const keywordSelector = document.getElementById('presentation_presentation_keywords_attributes_' + index + '_keyword_id');
            keywordSelector.addEventListener('change', function () {
                const input = document.getElementById('presentation_presentation_keywords_attributes_' + index + '_other_keyword');
                if (this.length === this.selectedIndex + 1) {
                    enableElement(input);
                    requireElement(input);
                    input.focus();
                } else {
                    input.value = '';
                    unrequireElement(input);
                    disableElement(input);
                }
            })
            const input = document.getElementById('presentation_presentation_keywords_attributes_' + index + '_other_keyword');
            if (keywordSelector.selectedIndex !== 0 && input.value === '') {
                unrequireElement(input);
                disableElement(input);
            }
        });

        function setIndex(index, element) {
            ['name', 'id'].forEach(attribute => {
                if (element.getAttribute(attribute) === null) {
                    return;
                }
                const value = element.getAttribute(attribute).replace(/\d+/, index);
                element.setAttribute(attribute, value);
            })
        }

        // Author card logic
        let currentAuthorIndex = Number(document.getElementById('author-cards').dataset.authorInitialSize);
        document.querySelectorAll('input.author-is-presenter').forEach((element) => {
            element.addEventListener('change', function () {
                if (this.checked) {
                    this.closest('.card-body').querySelectorAll('input.author-receipt-num').forEach((element) => {
                        enableElement(element);
                        requireElement(element);
                    });
                    this.closest('.card-body').querySelectorAll('span.author-receipt-num.text-error').forEach((element) => {
                        element.removeAttribute('hidden');
                    });
                } else {
                    this.closest('.card-body').querySelectorAll('input.author-receipt-num').forEach((element) => {
                        disableElement(element);
                        unrequireElement(element);
                        element.value = '';
                    });
                    this.closest('.card-body').querySelectorAll('span.author-receipt-num.text-error').forEach((element) => {
                        element.setAttribute('hidden', 'hidden');
                    });
                }
            })
        });
        if (currentAuthorIndex === 1) {
            document.getElementById('remove-author-btn').setAttribute('hidden', 'hidden');
        }


        function newAuthorForm(index) {
            const allAuthorForms = document.querySelectorAll('.author-card');
            const newForm = allAuthorForms[allAuthorForms.length - 1].cloneNode(true);
            newForm.querySelectorAll('input').forEach((element) => {
                setIndex(index, element);
                if (element.type === 'checkbox') {
                    element.removeAttribute('checked');
                    element.value = 0;
                    element.addEventListener('change', function () {
                        if (this.checked) {
                            this.closest('.card-body').querySelectorAll('input.author-receipt-num').forEach((element) => {
                                enableElement(element);
                                requireElement(element);
                            });
                            this.closest('.card-body').querySelectorAll('span.author-receipt-num.text-error').forEach((element) => {
                                element.removeAttribute('hidden');
                            });
                        } else {
                            this.closest('.card-body').querySelectorAll('input.author-receipt-num').forEach((element) => {
                                disableElement(element);
                                unrequireElement(element);
                                element.value = '';
                            });
                            this.closest('.card-body').querySelectorAll('span.author-receipt-num.text-error').forEach((element) => {
                                element.setAttribute('hidden', 'hidden');
                            });
                        }
                    })
                } else {
                    element.value = '';
                }
            });
            newForm.querySelectorAll('input.checkbox.author-is-presenter').forEach((element) => {
                element.removeAttribute('checked');
                element.value = 0;
            });
            newForm.querySelectorAll('input.author-order-num').forEach((element) => {
                element.setAttribute('value', index);
            });
            newForm.querySelectorAll('input.author-receipt-num').forEach((element) => {
                disableElement(element);
                unrequireElement(element);
            });
            newForm.querySelectorAll('span.author-receipt-num.text-error').forEach((element) => {
                element.setAttribute('hidden', 'hidden');
            });
            newForm.setAttribute('data-index', index);

            return newForm;
        }

        document.getElementById('add-author-btn').addEventListener('click', function () {
            currentAuthorIndex++;
            document.getElementById('author-cards').append(newAuthorForm(currentAuthorIndex));
            if (currentAuthorIndex > 0) {
                document.getElementById('remove-author-btn').removeAttribute('hidden');
            }
        });
        document.getElementById('remove-author-btn').addEventListener('click', function () {
            const allAuthorForms = document.querySelectorAll('.author-card');
            allAuthorForms[allAuthorForms.length - 1].remove();
            currentAuthorIndex--;
            if (currentAuthorIndex === 1) {
                document.getElementById('remove-author-btn').setAttribute('hidden', 'hidden');
            }
        });

        // Reference logic
        let currentReferenceIndex = Number(document.getElementById('references').dataset.referenceInitialSize);
        if (currentReferenceIndex === 1) {
            document.getElementById('remove-reference-btn').setAttribute('hidden', 'hidden');
        }

        function newReferenceForm(index) {
            const allReferenceForms = document.querySelectorAll('.reference');
            const newForm = allReferenceForms[allReferenceForms.length - 1].cloneNode(true)
            newForm.querySelectorAll('input').forEach((element) => {
                setIndex(index, element);
                element.value = '';
            });
            newForm.querySelectorAll('span').forEach((element) => {
                element.innerText = element.innerText.replace(/\d+/, index);
            });
            newForm.querySelectorAll('input.reference-order-num').forEach((element) => {
                element.setAttribute('value', index);
            });
            newForm.setAttribute('data-index', index);
            return newForm;
        }

        document.getElementById('add-reference-btn').addEventListener('click', function () {
            currentReferenceIndex++;
            document.getElementById('references').append(newReferenceForm(currentReferenceIndex));
            document.getElementById('remove-reference-btn').removeAttribute('hidden');
        });
        document.getElementById('remove-reference-btn').addEventListener('click', function () {
            const allReferenceForms = document.querySelectorAll('.reference');
            allReferenceForms[allReferenceForms.length - 1].remove();
            currentReferenceIndex--;
            if (currentReferenceIndex === 1) {
                document.getElementById('remove-reference-btn').setAttribute('hidden', 'hidden');
            }
        });
    }
}